export default "__VITE_ASSET__CQA4S2FJ__"